export const CourseHomeConstants = {
    GETALL_REQUEST: 'COURSEHOME_GETALL_REQUEST',
    GETALL_SUCCESS: 'COURSEHOME_GETALL_SUCCESS',
    GETALL_FAILURE: 'COURSEHOME_GETALL_FAILURE',

    SAVE_REQUEST: 'COURSEHOME_SAVE_REQUEST',
    SAVE_SUCCESS: 'COURSEHOME_SAVE_SUCCESS',
    SAVE_FAILURE: 'COURSEHOME_SAVE_FAILURE',

    UPDATE_REQUEST: 'COURSEHOME_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'COURSEHOME_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'COURSEHOME_UPDATE_FAILURE',

};



// WEBPACK FOOTER //
// ./src/_constants/course-home.constants.js